import axios from 'axios';
import {
  INVOICE_DATA_ALL_RECORDS_REQUEST,
  INVOICE_DATA_ALL_RECORDS_SUCCESS,
  INVOICE_DATA_ALL_RECORDS_FAIL,
  INVOICE_DATA_CREATE_REQUEST,
  INVOICE_DATA_CREATE_SUCCESS,
  INVOICE_DATA_CREATE_FAIL,
  INVOICE_DATA_UPDATE_REQUEST,
  INVOICE_DATA_UPDATE_SUCCESS,
  INVOICE_DATA_UPDATE_FAIL,
  INVOICE_DATA_DELETE_REQUEST,
  INVOICE_DATA_DELETE_SUCCESS,
  INVOICE_DATA_DELETE_FAIL,
} from '../constants/invoiceDataConstants';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const authConfig = (userInfo) => ({
  headers: { Authorization: `Bearer ${userInfo.token}` },
});

const authJsonConfig = (userInfo) => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userInfo.token}`,
  },
});

export const fetchAllInvoiceRecords = (month = '', year = '') => async (dispatch, getState) => {
  try {
    dispatch({ type: INVOICE_DATA_ALL_RECORDS_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.get(
      `${API_URL}/invoice-data/all-records?month=${month}&year=${year}`,
      authConfig(userInfo),
    );
    dispatch({ type: INVOICE_DATA_ALL_RECORDS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: INVOICE_DATA_ALL_RECORDS_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const createInvoiceRecord = (recordData) => async (dispatch, getState) => {
  try {
    dispatch({ type: INVOICE_DATA_CREATE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.post(`${API_URL}/invoice-data`, recordData, authJsonConfig(userInfo));
    dispatch({ type: INVOICE_DATA_CREATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: INVOICE_DATA_CREATE_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const updateInvoiceRecord = (id, recordData) => async (dispatch, getState) => {
  try {
    dispatch({ type: INVOICE_DATA_UPDATE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.put(`${API_URL}/invoice-data/${id}`, recordData, authJsonConfig(userInfo));
    dispatch({ type: INVOICE_DATA_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: INVOICE_DATA_UPDATE_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const deleteInvoiceRecord = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: INVOICE_DATA_DELETE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    await axios.delete(`${API_URL}/invoice-data/${id}`, authConfig(userInfo));
    dispatch({ type: INVOICE_DATA_DELETE_SUCCESS });
  } catch (error) {
    dispatch({ type: INVOICE_DATA_DELETE_FAIL, payload: error.response?.data?.message || error.message });
  }
};
